export const isLoading = state => state.studiesReducer.studentCourseSession.note.isLoading

export const isSuccess = state => state.studiesReducer.studentCourseSession.note.isSuccess

export const notes = state => state.studiesReducer.studentCourseSession.note.notes

export const options = state => state.studiesReducer.studentCourseSession.note.options

export const permissions = state => state.studiesReducer.studentCourseSession.note.permissions
